module.exports = __webpack_public_path__ + "fonts/iconfont.17ede686.ttf";